import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import UIButton from 'UIComponents/button/UIButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import UILink from 'UIComponents/link/UILink';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { LEARN_ABOUT_HS_VIDEO_LINK, RequestStatus } from '../../Constants';
import * as Video2OptInActions from '../../actions/Video2OptInStatus';
import { getHasVideoIntegrationScope, getIsUserSuperAdmin } from '../../selectors/Auth';
import { getIsVideo2Enabled, getOptInFetchStatus, getIsVideo2AssumedOptedIn, getOpenModal } from '../../selectors/Video2OptInStatus';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const propTypes = {
  forEmptyState: PropTypes.bool,
  hasVideoIntegrationScope: PropTypes.bool,
  isSuperAdmin: PropTypes.bool.isRequired,
  isVideo2Enabled: PropTypes.bool.isRequired,
  openOptOutModal: PropTypes.func.isRequired,
  optInFetchStatus: PropTypes.oneOf(Object.keys(RequestStatus)).isRequired,
  openOptInModal: PropTypes.func.isRequired,
  isVideo2AssumedOptedIn: PropTypes.bool.isRequired,
  openModal: PropTypes.string
};
const ToggleVideoFeatures = ({
  hasVideoIntegrationScope,
  isSuperAdmin,
  isVideo2Enabled,
  optInFetchStatus,
  forEmptyState,
  openOptInModal,
  openOptOutModal,
  isVideo2AssumedOptedIn
}) => {
  if (!hasVideoIntegrationScope || optInFetchStatus !== RequestStatus.SUCCEEDED || forEmptyState && isVideo2Enabled) {
    return null;
  }
  let linkKey = 'FileManagerCore.videoOptIn.toggle.turnOn';
  if (forEmptyState) {
    linkKey = 'FileManagerCore.videoOptIn.emptyStateLink';
  } else if (isVideo2AssumedOptedIn && isVideo2Enabled) {
    linkKey = 'FileManagerCore.videoOptIn.toggle.turnOff';
  }
  const onClickToggle = () => {
    const target = forEmptyState ? 'empty-state' : 'header-link';
    if (isVideo2AssumedOptedIn) {
      openOptOutModal(target);
    } else {
      openOptInModal(target);
    }
  };
  const learnMore = /*#__PURE__*/_jsx(UILink, {
    external: true,
    href: LEARN_ABOUT_HS_VIDEO_LINK,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "FileManagerCore.videoOptIn.learnMore"
    })
  });
  return /*#__PURE__*/_jsx(UITooltip, {
    disabled: isSuperAdmin,
    placement: "bottom",
    maxWidth: 400,
    title: /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "FileManagerCore.videoOptIn.toggle.nonAdminTooltip",
      options: {
        learnMore
      }
    }),
    children: /*#__PURE__*/_jsxs(UIButton, {
      use: "link",
      onClick: onClickToggle,
      disabled: !isSuperAdmin,
      "data-test-id": "video2-optin-toggle",
      "data-test-is-opted-in": isVideo2AssumedOptedIn,
      children: [!forEmptyState && /*#__PURE__*/_jsx(UIIcon, {
        name: "insertVideo",
        size: "small"
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: linkKey
      })]
    })
  });
};
ToggleVideoFeatures.propTypes = propTypes;
const mapDispatchToProps = {
  openOptInModal: Video2OptInActions.openOptInModal,
  openOptOutModal: Video2OptInActions.openOptOutModal
};
const mapStateToProps = state => ({
  hasVideoIntegrationScope: getHasVideoIntegrationScope(state),
  isSuperAdmin: getIsUserSuperAdmin(state),
  isVideo2Enabled: getIsVideo2Enabled(state),
  optInFetchStatus: getOptInFetchStatus(state),
  isVideo2AssumedOptedIn: getIsVideo2AssumedOptedIn(state),
  openModal: getOpenModal(state)
});
export default connect(mapStateToProps, mapDispatchToProps)(ToggleVideoFeatures);